<ng-container *ngIf="isVisible()">
  <ng-container *ngIf="isVimeoMedia() || isUnspecifiedVimeoVideoMedia(); then vimeoMedia"></ng-container>
  <ng-container *ngIf="isYouTubeMedia() || isUnspecifiedYoutubeVideoMedia() ; then youtubeMedia"></ng-container>
  <ng-container *ngIf="isImageMedia(); then imageMedia"></ng-container>
</ng-container>
<ng-template #vimeoMedia>
  <div>
    <iframe
      [width]="sW$ | async"
      [height]="sH$ | async"
      [src]="media.url | vimeoUrl"
      [title]="media.title"
      allowfullscreen
      style="border: none;"
      mozallowfullscreen
      webkitallowfullscreen
    ></iframe>
  </div>
</ng-template>
<ng-template #youtubeMedia>
  <youtube-player
    [title]="media.title"
    [videoId]="media.url | youTubeUrl"
    [width]="sW$ | async"
    [height]="sH$ | async"
    [placeholderImageQuality]="mediaQuality"></youtube-player>
</ng-template>
<ng-template #imageMedia>
  <cx-media [alt]="media.altText" [container]="media" [title]="media.title"></cx-media>
</ng-template>
